import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./template-task-creation.scss";
import uploadFilesIcon from "../../../../../assets/img/upload-files-icon.svg";
import deleteButton from "../../../../../assets/icons/Icon - Delete File.svg";
import {
  BrowseFiles,
  DeleteBrowseFile,
  GetIcon,
  PrepareDisplayFiles,
} from "../template-task-utility";
import PropTypes from "prop-types";
import {
  checkInvalidFiles,
  validFileTypes,
} from "../../../../../util/file-helpers";

const TemplateTaskCreationPanelFormMiddleUploadNew = ({
  values,
  setFieldValue,
}) => {
  const Drop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let fileArray = Array.from(e.dataTransfer.files);

    if (!checkInvalidFiles(fileArray).error) {
      let uploadFiles = [...e.dataTransfer.files];
      const filesToDisplay = PrepareDisplayFiles(
        values.Attachments,
        uploadFiles
      );
      setFieldValue("AddedFormFiles", uploadFiles);
      setFieldValue("Attachments", filesToDisplay);
    }

    e.dataTransfer.clearData();
  };

  const DragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "move";
  };

  const DragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const DragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onFileAdd = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let uploadFiles = BrowseFiles(e, values.AddedFormFiles ?? []);
    const filesToDisplay = PrepareDisplayFiles(values.Attachments, uploadFiles);
    setFieldValue("AddedFormFiles", uploadFiles);
    setFieldValue("Attachments", filesToDisplay);
  };

  const DeleteFiles = (file) => {
    let { resultantAttachments, resultantAddedFormFiles } = DeleteBrowseFile(
      file,
      values.Attachments,
      values.AddedFormFiles
    );
    setFieldValue("Attachments", resultantAttachments);
    setFieldValue("AddedFormFiles", resultantAddedFormFiles);
  };

  return (
    <>
      <Form.Group className="template-task-left-dropdown">
        <div
          className="template-task-upload-section"
          onDrop={Drop}
          onDragOver={DragOver}
          //onDragStart={DragStart}
          onDragEnter={DragEnter}
          onDragLeave={DragLeave}
        >
          <Form.Label className="template-task-upload-section">
            Upload/Drop Your Files Here
          </Form.Label>
          <Form.Group className="template-task-upload-file-box">
            <Form.Control
              className="template-task-browse-btn-hidden"
              type="file"
              multiple
              onChange={onFileAdd}
            />
            <img
              className="template-task-file-icon"
              src={uploadFilesIcon}
              alt={"Upload Files Icon"}
            ></img>
            <div className="file-text-placeholder">
              Upload .docx, .pptx, .xlsx, .pdf here
            </div>

            <input
              type="file"
              accept={validFileTypes.join(",")}
              multiple
              onChange={onFileAdd}
              className="template-task-browse-file-btn"
            />
          </Form.Group>
        </div>
      </Form.Group>

      <div
        className={
          values.Attachments.length < 6
            ? "template-task-file-display"
            : "template-task-scroll-display"
        }
      >
        {values.Attachments.map((file, index) => {
          const icon = GetIcon(file.FileName);
          return (
            <tr
              className={
                index === values.Attachments.length - 1
                  ? "template-task-last-row"
                  : "template-task-file-row"
              }
              key={index}
            >
              <td className="template-task-icon-column">
                {icon}
                <div className="template-task-vertical-line" />
              </td>

              <td className="template-task-file-name">{file.FileName}</td>

              <td className="template-task-file-size">
                {`Size: ${file.FileSize} Kb`}
              </td>

              <td className="template-task-delete-column">
                <Button
                  className="template-task-delete-file-btn"
                  onClick={() => DeleteFiles(file.FileName)}
                >
                  <img
                    src={deleteButton}
                    alt={"Remove attachment"}
                    className="template-task-remove-attachment"
                  />
                </Button>
              </td>
            </tr>
          );
        })}
      </div>
    </>
  );
};

TemplateTaskCreationPanelFormMiddleUploadNew.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default TemplateTaskCreationPanelFormMiddleUploadNew;
